function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8f8d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8f8d"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("8VVoY", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("JSq6p")).then(()=>parcelRequire("50i7i"));

});

var $baa0d15c0af437e2$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"aT88m":"index.e18e3b2e.js","JSq6p":"webfontloader.0ec8d36b.js"}'));

// var levelConfig = levelConfig || {};
const $843737fd5ac27bc4$export$59b3ce831ab0bb7d = [
    {
        level: 1,
        tiles: [
            "cactus",
            "fish",
            "helicopter"
        ],
        time: 60
    },
    {
        level: 2,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice"
        ],
        time: 60
    },
    {
        level: 3,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone"
        ],
        time: 60
    },
    {
        level: 4,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone",
            "rocket"
        ],
        time: 60
    },
    {
        level: 5,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone",
            "rocket",
            "pencil"
        ],
        time: 60
    },
    {
        level: 6,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone",
            "rocket",
            "pencil",
            "smile"
        ],
        time: 60
    },
    {
        level: 7,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone",
            "rocket",
            "pencil",
            "smile",
            "tree"
        ],
        time: 60
    },
    {
        level: 8,
        tiles: [
            "cactus",
            "fish",
            "helicopter",
            "ice",
            "megaphone",
            "rocket",
            "pencil",
            "smile",
            "tree",
            "trumpet"
        ],
        time: 60
    }
];



function $22f5f922ddc3e706$export$9c04d8fd885bb013(element, action) {
    if ("ontouchstart" in window) element.addEventListener("touchstart", action, {
        passive: false
    });
    else element.addEventListener("mousedown", action, {
        passive: false
    });
}
function $22f5f922ddc3e706$export$9a23bd5abbd0d648() {
    // Register gesturestart to prevent complex events
    document.addEventListener("gesturestart", (e)=>{
        e.preventDefault();
        $22f5f922ddc3e706$var$registerEvent("gesturestart");
    }, {
        passive: false
    });
    // Handle default mouse down OR touch start to prevent pinch zoom etc.
    $22f5f922ddc3e706$export$9c04d8fd885bb013(document, (e)=>{
        $22f5f922ddc3e706$var$registerEvent("prevent " + e.type);
        e.preventDefault();
    });
    // Catch move events
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) window.document.addEventListener("touchmove", (e)=>{
        $22f5f922ddc3e706$var$registerEvent("ios touch move");
        e.preventDefault();
    }, {
        passive: false
    });
}
function $22f5f922ddc3e706$var$registerEvent(name) {
    if (document.getElementById("messages")) document.getElementById("messages").innerHTML = name + "<br>" + document.getElementById("messages").innerHTML;
// if (top.document.getElementById('messages')) {
//   top.document.getElementById('messages').innerHTML = name + '<br>' + top.document.getElementById('messages').innerHTML;
// }
}


// Message to the platform

class $c39ed129cd641cb9$export$2dffd0b5373a4389 {
    constructor(){
        this.game = undefined;
        window.addEventListener("message", (ev)=>{
            this.receive(ev.data);
        });
        window.pew = this;
    }
    receive(data) {
        if (!this.game) {
            console.error("Error: Game not set");
            return;
        }
        switch(data.eventName){
            case "play":
                this.game.play(); // Send play message to the game
                break;
            case "restart":
                this.game.restart();
        }
    }
    init(game, config) {
        this.game = game;
        // Load fonts and then send ready event
        let fonts = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = "" + v;
            if (key === "font" && !fonts.includes(value) && !$c39ed129cd641cb9$var$excludedFonts.includes(value)) fonts.push(value);
        }
        console.log(fonts);
        if (fonts.length > 0) (parcelRequire("8VVoY")).then((webfont)=>{
            webfont.load({
                google: {
                    families: fonts
                },
                active: ()=>{
                    this.ready();
                }
            });
        });
        else this.ready();
    }
    /**
	 * Retrieve play event when game actualy starts
	 */ gamestarted() {
        // console.log('G: SEND', 'play');
        this.sendEvent({
            eventName: "start"
        });
    }
    resume() {
        this.sendEvent({
            eventName: "resume"
        });
    }
    play() {
        this.game?.play();
    }
    /**
	 * Retrieve gameover event from game whith endsoce
	 */ gameover(score) {
        this.sendEvent({
            eventName: "gameover",
            data: {
                score: score
            }
        });
    }
    /**
	 * Receive ready event from game when allowed to use start
	 */ ready() {
        this.sendEvent({
            eventName: "ready"
        });
    }
    pause() {
        this.sendEvent({
            eventName: "pause"
        });
    }
    playSound(sound) {
        this.sendEvent({
            eventName: "sound",
            data: sound
        });
    }
    preloadSounds(config) {
        let files = [];
        for (const [key, v] of Object.entries(config)){
            if (!v) continue;
            const value = config.path + "/" + v;
            if (!files.includes(value) && key.includes("Sound")) files.push(value);
        }
        this.sendEvent({
            eventName: "preload-sounds",
            data: files
        });
    }
    /**
	 * Send message to the game platform
	 * @param event
	 */ sendEvent(event) {
        window?.parent?.postMessage(event, "*");
    }
    sendScore(score, showAnim) {
        if (showAnim) {
            this.sendEvent({
                eventName: "score",
                data: {
                    score: Math.round(score)
                }
            });
            return;
        }
        this.sendEvent({
            eventName: "score",
            data: Math.round(score)
        });
    }
    sendTimeleft(time) {
        this.sendEvent({
            eventName: "timeleft",
            data: time
        });
    }
}
const $c39ed129cd641cb9$var$excludedFonts = [
    "Arial",
    "Helvetica",
    "Comic Sans MS",
    "Courier New",
    "Courier",
    "Georgia",
    "Lucida Sans Unicode",
    "Lucida Grande",
    "Geneva",
    "Times New Roman",
    "Trebuchet",
    "Verdana"
];


class $0550c724745f8dde$export$5fe42985de778c84 {
    constructor(id){
        this.id = id;
        this.el = document.getElementById(id);
        document.body.removeChild(this.el);
        if (!this.el) throw Error("Template " + id + " not found");
    }
    setVar(varname, value) {
        this.content.querySelector("span[content='" + varname + "']").innerHTML = value;
    }
    addTo(el) {
        this.el.content.childNodes.forEach((cn)=>{
            el.appendChild(cn.cloneNode(true));
        });
        return el;
    }
}



class $294a9ab98e704f61$export$235cb65c20ad2b7 {
    constructor(game, title, version){
        this.title = title;
        this.flipped = false;
        this.game = game;
        this.version = version;
        this.matched = false;
    }
    setElement(td) {
        this.el = td;
        // register click or touch events
        (0, $22f5f922ddc3e706$export$9c04d8fd885bb013)(this.el, this.cardClicked.bind(this));
    // (this.el.querySelector('.back') as HTMLImageElement).style.visibility = 'hidden';
    // (this.el.querySelector('.front') as HTMLImageElement).style.visibility = 'visible';
    }
    isSame(tile) {
        if (tile.title === this.title && tile.version === this.version) return true;
        return false;
    }
    isMatch(tile) {
        if (tile.title === this.title && tile.version !== this.version) return true;
        return false;
    }
    flip() {
        this.flipped = true;
        this.update();
    }
    unflip() {
        this.flipped = false;
        this.update();
    }
    match() {
        this.matched = true;
        this.el.querySelector(".card").classList.add("match");
    }
    update() {
        if (!this.flipped) this.el.querySelector(".card").classList.remove("flipped");
        else this.el.querySelector(".card").classList.add("flipped");
    }
    cardClicked(e) {
        if (this.matched) return;
        this.game.handleTileClick(this);
    }
}


class $e46db5192eb49d53$export$29d4d7bc03c348a5 {
    constructor(){
        this.debug = false;
        this.currentScore = 0;
        this.multiplier = 0;
        this.loops = 0;
        this.score = 0;
        this.flipping = false;
        this.templates = {
            game: new (0, $0550c724745f8dde$export$5fe42985de778c84)("template-game"),
            card: new (0, $0550c724745f8dde$export$5fe42985de778c84)("template-card")
        };
        this.state = "init";
        this.images = [];
        this.imageLoadCount = 0;
        this.config = {
            nextLevelTimeout: 2000,
            fontColor: "#000",
            fontOffsetY: 0,
            fontSize: 30,
            scoreBarColor: "#499D2E",
            scoreBarBackgroundColor: "#499D2E",
            scoreBarBorderColor: "#000",
            scoreBarBorderRadius: 5,
            scoreBarBorderWidth: 3,
            scoreBarOffsetY: 0,
            cardFrontBorderColor: "#000",
            cardBackBorderColor: "#000",
            cardBorderRadius: 10,
            cardBorderWidth: 10,
            cardFrontBackgroundColor: "#fff",
            gridOffsetY: 0,
            backgroundImage: "vuur.jpeg",
            cardSize: 3000,
            cardMargin: 2,
            maxColumns: 4,
            levels: "",
            unflipTime: 500,
            checkInterval: 100,
            maxLoops: 0,
            scorePerMatch: 100,
            bonusPerMs: 10,
            speedUp: 10,
            path: "https://gamecdn.playenwin.com/wietse/memory/default/",
            font: "Acme",
            tileSelectSound: "",
            matchSound: "",
            noMatchSound: "",
            timeBonusSound: ""
        };
        this.sounds = {
            tileSelect: undefined,
            match: undefined,
            noMatch: undefined,
            timeBonus: undefined
        };
        if (window.location.search.search("debug") !== -1) this.debug = true;
        (0, $22f5f922ddc3e706$export$9a23bd5abbd0d648)();
        this.loadConfig();
        if (this.config.levels) this.loadLevels();
        else this.allLevels = (0, $843737fd5ac27bc4$export$59b3ce831ab0bb7d);
        this.init();
    }
    loadConfig() {
        const urlParams = new URLSearchParams(window.location.search);
        // Patch settings
        if (urlParams.get("s")) {
            const settings = atob(urlParams.get("s") || "").split("\n").filter((s)=>s.trim() !== "").map((s)=>{
                return {
                    name: s.split("=")[0].trim(),
                    value: s.split("=")[1].trim()
                };
            });
            settings.forEach((s)=>{
                if (!isNaN(+s.value)) this.config[s.name] = +s.value;
                else if (s.value === "true") this.config[s.name] = true;
                else if (s.value === "false") this.config[s.name] = false;
                else this.config[s.name] = s.value;
            });
        }
    }
    loadLevels() {
        this.allLevels = [];
        const rawLevels = this.config.levels.split(";");
        rawLevels.forEach((rawLevel)=>{
            if (rawLevel === "") return;
            const levelData = rawLevel.split(",");
            const time = +levelData.splice(0, 1);
            const cards = levelData;
            const level = {
                level: this.allLevels.length + 1,
                tiles: cards.map((c)=>c.trim()),
                time: time
            };
            this.allLevels.push(level);
        });
    }
    init() {
        this.platform = new (0, $c39ed129cd641cb9$export$2dffd0b5373a4389)();
        this.platform.preloadSounds(this.config);
        this.elmCanvas = document.getElementById("canvas");
        this.templates.game.addTo(this.elmCanvas);
        this.elmTable = this.elmCanvas.querySelector("#cardsContainer");
        this.elmTest = this.elmCanvas.querySelector("#test");
        document.body.style.color = this.config.fontColor;
        const imageNames = [];
        this.allLevels.forEach((l)=>{
            l.tiles.forEach((tileName)=>{
                if (imageNames.indexOf(tileName) === -1) imageNames.push(tileName);
            });
        });
        const cache = this.debug ? "?" + Date.now() : "";
        imageNames.forEach((imagename)=>{
            let img = new Image();
            img = new Image();
            img.src = this.config.path + "/" + imagename;
            img.onload = (e)=>this.checkImages();
            this.images.push(img);
        });
        let img = new Image();
        img = new Image();
        img.src = this.config.path + "/" + this.config.backgroundImage + cache;
        img.onload = (e)=>this.checkImages();
        this.images.push(img);
    }
    checkImages() {
        this.imageLoadCount++;
        if (this.imageLoadCount === this.images.length) {
            this.initReady();
            this.prepareGame();
        }
    }
    initReady() {
        this.platform.init(this, this.config);
    }
    restart() {
        this.prepareGame();
        this.platform.ready();
    }
    prepareGame() {
        this.currentLevel = null;
        this.multiplier = 0;
        this.currentScore = 0;
        this.setScore(0);
        this.loops = 0;
        // Create tiles in grid
        this.prepareLevel();
        this.state = "ready";
    }
    prepareLevel() {
        if (!this.loadNextTileDeck()) {
            this.gameover();
            // console.log('Game ended');
            return;
        }
        this.firstPick = null;
        this.secondPick = null;
        this.platform.sendTimeleft(100);
        this.loadGrid();
        this.showGrid();
        this.unmatchedPairs = this.currentLevel.tiles.length;
        this.levelState = "init";
        this.currentTimeLeft = this.currentLevel.time;
    }
    play() {
        if (this.state !== "ready") return;
        (0, $ad2bcec7a0192558$export$140d7860bc6d1e6e)("start playing");
        this.state = "playing";
    }
    // For PlayAndWinPlatForm
    mute(mute) {
        Howler.mute(mute);
    }
    startTimer() {
        if (this.levelState === "started") return;
        this.currentTimeLeft = this.currentLevel.time;
        this.levelState = "started";
        this.startTimerBar(this.timesUp.bind(this));
    }
    stopTimer() {
        (0, $ad2bcec7a0192558$export$140d7860bc6d1e6e)("stop timer called");
        window.clearInterval(this.currentTimer);
    }
    timesUp(e) {
        if (this.levelState === "started") this.gameover();
    }
    gameover() {
        // Set to gameover state
        this.state = "gameover";
        console.log("Score: ", this.currentScore);
        this.platform.gameover(Math.round(this.currentScore));
    }
    showGrid() {
        const rows = this.tileGrid.length;
        const cols = this.tileGrid[0].length;
        let cardSize = 60;
        switch(cols){
            case 1:
                cardSize = 150;
                break;
            case 2:
                cardSize = 100;
                break;
            case 3:
                cardSize = 80;
                break;
            case 4:
                cardSize = 70;
                break;
            case 5:
                cardSize = 60;
                break;
        }
        if (rows > 5) cardSize = 50;
        if (rows > 6) cardSize = 45;
        if (rows > 7) cardSize = 40;
        this.config.cardSize = cardSize;
        // Clean table
        this.elmTable.innerHTML = "";
        this.elmTest.innerHTML = "";
        // Add cells to table
        this.tileGrid.forEach((gridrow)=>{
            const tableRow = document.createElement("div");
            gridrow.forEach((tile)=>{
                const tableCell = document.createElement("div");
                this.templates.card.addTo(tableCell);
                const urlBack = this.config.path + "/" + tile.title;
                const urlFront = this.config.path + "/" + this.config.backgroundImage;
                tableCell.querySelector(".back").src = urlBack; //  "url('assets/img/" + tile.title + ".png')";
                tableCell.querySelector(".front").src = urlFront;
                tile.setElement(tableCell);
                tableCell.querySelector(".card .front").style.borderColor = this.config.cardBackBorderColor;
                tableCell.querySelector(".card .back").style.borderColor = this.config.cardFrontBorderColor;
                tableCell.querySelector(".card .back").style.borderRadius = this.config.cardBorderRadius + "px";
                tableCell.querySelector(".card .front").style.borderRadius = this.config.cardBorderRadius + "px";
                tableCell.querySelector(".card .front").style.borderWidth = this.config.cardBorderWidth + "px";
                tableCell.querySelector(".card .back").style.borderWidth = this.config.cardBorderWidth + "px";
                // (<HTMLImageElement>tableCell.querySelector('.card img')).style.borderWidth = this.config.cardBorderWidth + 'px';
                tableCell.querySelector(".card .back").style.backgroundColor = this.config.cardFrontBackgroundColor;
                tableCell.querySelector(".container").style.width = this.config.cardSize + "px";
                tableCell.querySelector(".container").style.height = this.config.cardSize + "px";
                tableCell.querySelector(".container").style.margin = this.config.cardMargin + "px";
                tableRow.appendChild(tableCell);
            });
            this.elmTest.appendChild(tableRow);
        });
    }
    handleTileClick(tile) {
        if (this.state !== "playing") {
            (0, $ad2bcec7a0192558$export$140d7860bc6d1e6e)("Game is not yet started State: " + this.state);
            return;
        }
        // If first click on a card, the timer should be started
        if (this.levelState === "init") {
            this.platform.gamestarted();
            this.platform.resume();
            this.startTimer();
        }
        // Already completed. Do nothing
        if (this.levelState === "complete") return;
        // Already 2 cards in action. Do nothing
        if (this.secondPick) return; // still active second
        // First card
        if (!this.firstPick) {
            this.playSound("tileSelect");
            this.firstPick = tile;
            tile.flip();
            return;
        }
        // Second card clicked
        // Register card and show flip
        this.secondPick = tile;
        if (this.firstPick.isSame(this.secondPick)) {
            this.playSound("tileSelect");
            this.firstPick.unflip();
            window.setTimeout((e)=>{
                this.firstPick = null;
                this.secondPick = null;
            }, this.config.unflipTime);
            return;
        }
        tile.flip();
        this.playSound("tileSelect");
        this.flipping = true;
        // If no match, unflip after 500ms
        if (!this.firstPick.isMatch(this.secondPick)) {
            window.setTimeout((e)=>{
                this.firstPick.unflip();
                this.secondPick.unflip();
                this.firstPick = null;
                this.secondPick = null;
                this.playSound("noMatch");
                this.flipping = false;
            }, this.config.unflipTime);
            // no further actions until unflip is performed
            return;
        }
        // Match is made, show animation after css delay, cards are disabled after this
        this.firstPick.match();
        this.secondPick.match();
        setTimeout(()=>{
            this.playSound("match");
            this.currentScore += this.config.scorePerMatch;
            this.setScore(this.currentScore);
            this.flipping = false;
        }, 500);
        this.firstPick = null;
        this.secondPick = null;
        // Register hit
        this.unmatchedPairs--;
        // Add score
        // Show score
        // this.setScore(this.currentScore);
        if (this.unmatchedPairs > 0) // Continue with next cards
        return;
        this.levelState = "complete";
        this.platform.pause();
        // Stop timer
        this.stopTimer();
        // Wait for 1000ms and start bringing down the score
        window.setTimeout((e)=>{
            this.emptyBar(this.LevelComplete.bind(this));
        }, this.config.unflipTime * 2);
    }
    // Called when scorebar is back to 0 and points are added
    LevelComplete() {
        //  Make score final and show
        this.currentScore += Math.max(0, this.currentTimeLeft * this.config.bonusPerMs);
        this.setScore(this.currentScore);
        // Prepare  next level after timeout
        window.setTimeout((e)=>{
            this.prepareLevel();
        }, this.config.nextLevelTimeout);
    }
    /**
	 * @param {totalTime} levelTime
	 * @param {timeInterval} timeInterval
	 * @param {levelCompleteOrFailed} levelComplete
	 * @param {StartpositionofBar} startPos
	 */ startTimerBar(onZero) {
        const levelTime = this.currentLevel.time;
        let startTime = Date.now();
        this.currentTimeLeft = levelTime;
        this.currentTimer = window.setInterval(()=>{
            if (this.levelState !== "started") return;
            const delta = Date.now() - startTime;
            this.currentTimeLeft = Math.max(-100, levelTime - Math.round(delta)); // whole seconds
            let progressTimeLeft = Math.max(0, levelTime - delta);
            const progress = Math.min(100, Math.max(0, this.currentTimeLeft / this.currentLevel.time * 100));
            this.platform.sendTimeleft(progress);
            if (this.currentTimeLeft <= -100 && !this.flipping) setTimeout(()=>{
                if (!this.flipping) {
                    window.clearInterval(this.currentTimer);
                    onZero();
                } else return;
            }, this.config.checkInterval);
        }, this.config.checkInterval);
    }
    emptyBar(onZero) {
        const interval = Math.round(this.currentTimeLeft / 1000 * 50); // 1 second devided per points
        // this.elmBar.style.width = '0%';
        let timeLeft = this.currentTimeLeft;
        const bonus = this.currentTimeLeft * this.config.bonusPerMs;
        let timer = window.setInterval((e)=>{
            timeLeft -= interval;
            const progress = Math.max(0, timeLeft / this.currentLevel.time * 100);
            this.setScore(this.currentScore + (this.currentTimeLeft - timeLeft) * this.config.bonusPerMs, false);
            this.platform.sendTimeleft(progress);
            this.playSound("timeBonus", true);
            if (timeLeft <= 0) {
                window.clearInterval(timer);
                onZero();
                return;
            }
        }, 50);
        return;
    }
    setScore(score, showAnim = true) {
        this.score = score;
        // this.elmScore.innerHTML = Math.round(this.score)
        // 	.toString()
        // 	.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.platform.sendScore(score, showAnim);
    }
    loadNextTileDeck() {
        console.log(this.allLevels);
        if (this.currentLevel == null) {
            this.currentLevel = {
                ...this.allLevels[0]
            };
            return true;
        }
        // Last Level
        if (this.currentLevel.level < this.allLevels.length) {
            this.currentLevel = {
                ...this.allLevels[this.currentLevel.level]
            };
            this.currentLevel.time = Math.max(5, this.currentLevel.time - this.multiplier * this.config.speedUp);
            return true;
        }
        // Loop back to first level
        this.loops++;
        if (this.config.maxLoops > 0 && this.loops >= this.config.maxLoops) // Game ended, no new level
        return false;
        // Next level, increase speed and start with first level
        this.currentLevel = {
            ...this.allLevels[0]
        };
        this.multiplier++;
        this.currentLevel.time = Math.max(5, this.currentLevel.time - this.multiplier * this.config.speedUp);
        return true;
    }
    loadGrid() {
        const tileNames = this.currentLevel.tiles;
        // Create array with all tiles
        const tileDeck = [];
        tileNames.forEach((name)=>{
            tileDeck.push(new (0, $294a9ab98e704f61$export$235cb65c20ad2b7)(this, name, 1));
            tileDeck.push(new (0, $294a9ab98e704f61$export$235cb65c20ad2b7)(this, name, 2));
        });
        let colCount = Math.min(this.config.maxColumns, Math.sqrt(this.currentLevel.tiles.length * 2));
        let rowCount = Math.round(this.currentLevel.tiles.length * 2 / colCount);
        switch(this.currentLevel.tiles.length){
            case 1:
                colCount = 1;
                rowCount = 2;
                break;
            case 2:
                colCount = 2;
                rowCount = 2;
                break;
            case 3:
                colCount = 2;
                rowCount = 3;
                break;
            case 4:
                colCount = 3;
                rowCount = 3;
                break;
            case 5:
                colCount = 3;
                rowCount = 4;
                break;
            case 6:
                colCount = 3;
                rowCount = 4;
                break;
            // case 7:
            //   colCount = 2;
            //   rowCount = 7;
            //   break;
            // case 8:
            //   colCount = 4;
            //   rowCount = 4;
            //   break;
            case 9:
                colCount = 4;
                rowCount = 5;
                break;
            case 10:
                colCount = 4;
                rowCount = 5;
                break;
        }
        // Determine grid dimension
        this.tileGrid = [];
        let amountOfTilesTotal = tileDeck.length;
        let currentTile = 0;
        for(let row = 0; row < rowCount; row++){
            this.tileGrid[row] = [];
            for(let col = 0; col < colCount; col++){
                if (currentTile >= amountOfTilesTotal) break;
                // Get a random card from the deck and add to grid location
                this.tileGrid[row][col] = tileDeck.splice(Math.floor(Math.random() * tileDeck.length), 1)[0];
                currentTile++;
            }
        }
    }
    playSound(soundKey, loop = false) {
        const config = this.config;
        if (config[soundKey + "Sound"]) this.platform.playSound(config.path + "/" + config[soundKey + "Sound"]);
    }
    printConfig(config) {
        let nice = "";
        for (const [key, value] of Object.entries(config))nice += key + "=" + value + "\n";
        console.log(nice);
    }
}


function $ad2bcec7a0192558$export$140d7860bc6d1e6e(...message) {
// console.log(...message);
}
document.addEventListener("DOMContentLoaded", (e)=>{
    // eslint-disable-next-line no-new
    new (0, $e46db5192eb49d53$export$29d4d7bc03c348a5)();
});


//# sourceMappingURL=index.e18e3b2e.js.map
